import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@niko-crm/ui';

export const superAdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const payload = await authService.getTokenPayload();
  if (!payload) {
    return router.createUrlTree(['/login']);
  }

  const groups = (payload['cognito:groups'] as string[]) ?? [];
  if (!groups.includes('SuperAdmin')) {
    return router.createUrlTree(['/unauthorized']);
  }

  return true;
};
